
import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import UsersList from './components/UsersList';
import EmployeesList from "./components/EmployeesList";
import PaymentInfo from './components/PaymentInfo';
import { beginning_of_month } from "./components/months";
import FlashMessage from '../../../components/FlashMessage/FlashMessage';

class ShowClients extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isSuccess: false,
      isOpen: false,
      successMessage: "",
      errorMessage: ""
    }
  }

  render() {

    const { clients, 
          users,
          user,
          employees,
          employee,
          usersSize, 
          employeesSize,
          role } = this.props.values;
    const detail = this.props.values;

    const employeeSync = (e) => {

      e.preventDefault();
      axios.put(`/desk/clients/${clients.id}/employees_sync`)
      .then((res) => {
        if(res.status === 200){
          this.setState({ successMessage: res.data });
          this.props.setOpen();
          this.props.setSuccess();
          setTimeout(() => {
            window.location.replace("/desk/clients");
          }, 1000)
        }
      })
      .catch((error) => {
        this.setState({ errorMessage: error.message });
        this.props.setOpen();
        this.props.setUnSuccess();
        setTimeout(() => {
          window.location.replace("/desk/clients");
        }, 1000)
      });
    }

  return (
    <React.Fragment>
      <FlashMessage  
          successMessage={this.state.successMessage} 
          failedMessage={this.state.errorMessage}
      />
      <div>
          <h2>
              <span><a href={`/desk/clients/${clients.id}`}>{clients.name} - 詳細</a></span>
          </h2>
          <div className="text-right">
            <a className="btn btn-primary" href={`/desk/clients/${clients.id}/edit`}>変更する</a>
          </div>
          <div className="row">
            <div className="col-sm-9">
              <article className="pair-list">
                <header>
                    <div className="title">
                        基本情報
                    </div>
                </header>
                <section>
                  <div className="title">
                    会社ID
                  </div>
                  <div className="content">
                    {detail.clientCode}
                  </div>
                </section>
                <section>
                  <div className="title">
                    給与計算内ID
                  </div>
                  <div className="content">
                    {clients.id}
                  </div>
                </section>
                <section>
                  <div className="title">
                    {detail.clientNameName}
                  </div>
                  <div className="content">
                    {clients.name}
                  </div>
                </section>
                <section>
                  <div className="title">
                    プラン
                  </div>
                  <div className="content">
                    {detail.planTypeI18n}
                    {!clients.planControllable ? <span className="badge badge-info">
                      閲覧・変更を禁止
                    </span> : undefined}
                  </div>
                </section>
                {clients.planType === 'paid_plan' ? <section
                >
                  <div className="title">
                    お試し期間期限
                  </div>
                  <div className="content">
                    l {clients.trialFinishAt}
                  </div>
                </section> : undefined}
                <section>
                  <div className="title">
                    ユーザー数
                  </div>
                  <div className="content">
                    <a href={`/desk/clients/${clients.id}/users`}>{detail.usersCount}</a>
                  </div>
                </section>
                <section>
                  <div className="title">
                    従業員数
                  </div>
                  <div className="content">
                    <a href={`/desk/clients/${clients.id}/employees`}>{detail.employeesCount}</a>
                    <button type="button" className="btn btn-primary btn-sm float-right" onClick={employeeSync} >共通IDの招待状況を再取得</button>
                  </div>
                </section>
                <section>
                  <div className="title">
                  請求予定数{beginning_of_month}月
                  </div>
                  <div className="content">
                    {/* Billing target section. In Thailand, there is no information and function related to payment information data.*/}
                  </div>
                </section>
                <section>
                  <div className="title">
                    {detail.deskMemoName}
                  </div>
                  <div className="content memo">
                    {clients.deskMemo}
                  </div>
                </section>
              </article>
            </div>
          </div>

          {/* payment info is not available */}
          {/* <PaymentInfo /> */}
          
          <UsersList users={users} clients={clients} userSize={usersSize} role={role} employee={employee}/>
          <div className="footer">
            <a className="btn btn-link btn-sm" href={`/desk/clients/${clients.id}/users`}>もっと見る</a>
          </div>
          <br />
          <EmployeesList employees={employees} clients={clients} employeesSize={employeesSize} user={user} />
          <div className="footer">
            <a className="btn btn-link btn-sm" href={`/desk/clients/${clients.id}/employees`}>もっと見る</a>
          </div>
          <div className="text-right u-mb40">
            <a className="btn btn-primary" href={`/desk/clients/${clients.id}/import_employees_csv/new	`}>CSVインポート</a>
          </div>
      </div>
    </React.Fragment>
     
    );
  }
}


const mapStateToProps = (state) => {
  return {
    isSuccess: state.flashMessage.isSuccess,
    isOpen: state.flashMessage.isOpen
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setSuccess: () => dispatch({type: 'SET_SUCCESS'}),
    setUnSuccess: () => dispatch({type: 'SET_UNSUCCESS'}),
    setOpen: () => dispatch({type: 'SET_OPEN'}) 
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ShowClients));